import React from 'react';
import Hero from '../Hero';
import FeaturedProducts from '../FeaturedProducts';
import HowItWorks from '../HowItWorks';
import { products } from '../products';

const HomePage = () => {
  return (
    <div className="homepage">
      <Hero />
      <FeaturedProducts products={products} />
      <HowItWorks />
    </div>
  );
};

export default HomePage;